import { Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableRow, TextField } from '@material-ui/core'
import React from 'react'
import { CheckListNotes } from '../reportWritersAgenda/CheckListNotes'
import { useAvailableCheckList } from '../../projectManagementQueries';

export const ApproverCheckListView = ({ open, onClose, id }: any) => {


    const {
        data: availableCheckListdata,
        isLoading: isLoadingAvailableCheckList,
        isError: isAvailableCheckListError,
        error: availableCheckListError,
        refetch: refetchAvailableCheckList,
    } = useAvailableCheckList(id);


    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
                <DialogTitle>Check List</DialogTitle>
                <DialogContent>
                    {isLoadingAvailableCheckList ? (
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="200px"
                            width="100%"
                        >
                            <CircularProgress size={40} />
                        </Box>
                    ) : (
                        <Grid container spacing={2} justifyContent="center">

                            <Grid item xs={4}>
                                <TextField
                                    id="report"
                                    name="report"
                                    label="Reports"
                                    value={availableCheckListdata?.[0]?.report_name ?? ""}
                                    fullWidth
                                    margin="dense"
                                    variant="outlined"
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid>



                            <Grid item xs={12}>
                                <TableContainer
                                    component={Paper}
                                    style={{
                                        marginTop: 16,
                                        border: "2px solid #B0B0B0",
                                        borderRadius: 8,
                                        padding: 18,
                                    }}
                                >
                                    <Table size="small">
                                        <TableBody>
                                            {availableCheckListdata?.[0].check_list?.map((checkList: any) => (
                                                <React.Fragment key={checkList.category}>

                                                    <TableRow style={{ backgroundColor: "#FFC107", height: 30 }}>
                                                        <TableCell
                                                            colSpan={3}
                                                            align="center"
                                                            style={{ fontWeight: "bold" }}
                                                        >
                                                            {checkList.category}
                                                        </TableCell>
                                                    </TableRow>


                                                    {checkList.check_point?.map((item: any) => (
                                                        <TableRow key={item.id} style={{ height: 30 }}>
                                                            <TableCell padding="none" style={{ marginLeft: 20 }}>{item.description}</TableCell>

                                                            <TableCell align="center" padding="none">
                                                                <Checkbox
                                                                    checked={item.status === true} 
                                                                    indeterminate={item.status === false}
                                                                    disabled
                                                                    style={{
                                                                        color: item.status === true ? "green" : "red",
                                                                    }}
                                                                />



                                                            </TableCell>

                                                            <TableCell align="center" padding="none">
                                                                <IconButton>
                                                                    <CheckListNotes
                                                                        id={id}
                                                                        check_list_report_id={availableCheckListdata?.[0]?.category_id}
                                                                        check_list_id={item.id}
                                                                        count={item.note_count}
                                                                        Writer={false}
                                                                    />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </React.Fragment>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>

                    )}

                </DialogContent>


                <DialogActions>
                    <Button onClick={onClose} variant="outlined">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    )
}


